import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Subscription } from 'rxjs';
import { ProfileService } from '../../services/profile.service';
import { CommonServicesForAllModules } from 'src/app/shared/common/service';
import { ToastService } from 'src/app/core/toast.service';
import { Tables } from 'src/app/shared/enum/tables.enum';
import { LoginService } from 'src/app/core/services/login.service';

export interface PartnershipRequest {
  id: string;
  company_name: string;
  contact_name: string;
  email: string;
  phone: string;
  status: string;
}

@Component({
  selector: 'app-partnership-request',
  templateUrl: './partnership-request.component.html',
  styleUrls: ['./partnership-request.component.scss']
})
export class PartnershipRequestComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  loginDetails: any;
  filteredPartners: PartnershipRequest[] = [];
  selectedTabStatus: string = 'ALL';
  selectedTabIndex: number = 0;
  pageSize: number = 10;
  pageIndex: number = 0;
  loading: boolean = false;
  private fetchSubscription?: Subscription;

  constructor(
    private profileService: ProfileService,
    private loginService: LoginService,
    private commonService: CommonServicesForAllModules,
    private toast: ToastService
  ) {}

  ngOnInit(): void {
     this.loginDetails = this.loginService.getLoginData();
    if (this.loginDetails?.type === 'SUPPLIER') {
      this.fetchPartnershipRequests();
    }
  }

  ngOnDestroy(): void {
    this.fetchSubscription?.unsubscribe();
  }

  // Fetch Partnership Requests
  fetchPartnershipRequests(): void {
    console.log('22222222')
    const supplierId = this.loginDetails?.id;
    if (!this.selectedTabStatus || !supplierId) return;

    const offset = this.pageIndex * this.pageSize;
    this.loading = true;
    this.fetchSubscription?.unsubscribe();

    this.fetchSubscription = this.profileService
      .getPartnershipRequestsByStatus(supplierId, this.selectedTabStatus, this.pageSize, offset)
      .subscribe({
        next: (data: PartnershipRequest[]) => {
              console.log('1-----',data)
          this.filteredPartners = this.pageIndex === 0 ? data : [...this.filteredPartners, ...data];
        console.log('filteredPartners',this.filteredPartners)

          this.loading = false;
        },
        error: (err) => {
          console.error('Failed to fetch partnership requests', err);
          this.loading = false;
        }
      });
  }

  onTabChange(status: string, index: number): void {
    if (this.selectedTabStatus === status) return;
    this.selectedTabStatus = status;
    this.selectedTabIndex = index;
    this.pageIndex = 0;
    this.filteredPartners = [];
    this.fetchPartnershipRequests();
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.fetchPartnershipRequests();
  }

  async updateStatus(partner: PartnershipRequest, newStatus: 'APPROVED' | 'REJECTED'): Promise<void> {
    try {
      const fields = { status: newStatus };
      this.loading = true;

      await this.commonService.UpdateData(Tables.Partnership_Members, partner.id, fields);
      this.toast.openSnackBar(`Partner has been ${newStatus.toLowerCase()} successfully.`);
      this.fetchPartnershipRequests();
      this.loading = false;
    } catch (error) {
      console.error('Failed to update partnership status:', error);
      this.toast.openSnackBar('Failed to update status. Please try again.');
      this.loading = false;
    }
  }
}
